import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0056D2',          
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#264FDA',
      light: '#D0E2FF',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F9F9FB',       
      paper: '#ffffff',          
    },
    text: {
      primary: '#000000',
      secondary: '#4a4a4a',
    },
    divider: '#E8E8EE',


    success: {
      main: '#2e7d32',           // Green
    },
    warning: {
      main: '#ed6c02',           // Orange
    },
    error: {
      main: '#d32f2f',           // Red
    },
    info: {
      main: '#0288d1',           // Cyan-ish
    },
  },

  shape: {
    borderRadius: 12, // Applies to cards, buttons, etc.
  },

  typography: {
    fontFamily: '"Inter", "Roboto", "Open Sans", sans-serif',
    h1: {
      fontSize: '2.2rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.75rem',
    },
    body1: {
      fontSize: '0.95rem',
    },
    button: {
      fontSize: '0.95rem',
      fontWeight: 600,
      textTransform: 'none',
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '2rem',
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '1rem',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
});
